<template>
  <v-card>
    <v-card-title class="title">Impact
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-layout
          row
          wrap
        >
          <template v-for="(impact, index) in impacts">
            <v-flex
              :key="'t' + index"
              xs8
              md3
            >
              <v-text-field
                v-model="impact.title"
                label="Title"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>

            <v-flex
              :key="'v' + index"
              xs4
              md3
            >
              <v-text-field
                v-model="impact.value"
                label="Value"
                :rules="[rules.required]"
                persistent-hint
              ></v-text-field>
            </v-flex>
          </template>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              @click.native="save"
            >Save</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
export default {
  data() {
    return {
      impacts: [],
      rules: {
        required: value => !!value || "Required."
      }
    };
  },

  mounted() {
    this.impacts = this.$store.getters.impactList;
  },

  methods: {
    save() {
      const formatted = {};
      this.impacts.forEach(impact => {
        formatted[impact.id] = impact;
      });

      this.$store.dispatch("saveImpact", formatted);
    }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/pages/ImpactPage.vue